import React, { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface BoxProps {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const useStyles = createUseStyles({
  container: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    marginBottom: '20px',
  },
  header: {
    padding: '20px',
    borderBottom: '1px solid #ebebeb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    padding: '20px',
  },
  footer: {
    borderTop: '1px solid #ebebeb',
    padding: '20px',
  },
});

const Box: React.FC<BoxProps> = ({
  children,
  header,
  footer,
  className = '',
  style = {},
}) => {
  const classes = useStyles();

  return (
    <div className={`${classes.container} ${className}`} style={style}>
      {header && (
        <div className={classes.header}>
          <div className={classes.title}>{header}</div>
        </div>
      )}
      <div className={classes.content}>{children}</div>
      {footer && <div className={classes.footer}>{footer}</div>}
    </div>
  );
};

export default Box;
